import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const listQueries = [
  'waiverLists',
  'waiverList',
];

/** Queries that consume list options through questions or template previews. */
const listDependentQueries = [
  ...listQueries,
  'waiverQuestions',
  'waiverQuestion',
  'waiverTemplates',
  'waiverTemplate',
  'waiverPublishedTemplates',
  'waiverForms',
  'waiverForm',
];

const waiverListMutations: UpdatesConfig['Mutation'] = {
  waiverListCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(listQueries, cache);
  },
  waiverListUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(listDependentQueries, cache);
  },
  waiverListStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(listDependentQueries, cache);
  },
};

export default waiverListMutations;
